<template>
  <a
    href="https://ddhq.io/"
    target="_blank">
    <div>
      <svg
        viewBox="0 0 220 79"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        height="14"
        width="42">
        <g clip-path="url(#clip0_1_601)">
          <path
            d="M149.707 30.6093H125.712V6.40723H113.418V66.1242H125.712V40.5348H149.707V66.1242H162.001V6.40723H149.707V30.6093Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M216.687 52.1625C218.49 48.051 219.398 43.1955 219.398 37.621V34.9599C219.398 29.1081 218.339 23.9498 216.22 19.4726C214.102 14.9954 211.114 11.565 207.243 9.18137C203.372 6.78512 198.959 5.59961 193.978 5.59961C188.997 5.59961 184.584 6.79773 180.713 9.18137C176.842 11.5776 173.854 15.008 171.736 19.4726C169.617 23.9372 168.558 29.1207 168.558 34.9978V37.949C168.583 43.6873 169.668 48.7699 171.799 53.184C173.93 57.5982 176.943 61.0034 180.814 63.3744C184.698 65.758 189.111 66.9436 194.054 66.9436C195.617 66.9436 197.118 66.8174 198.568 66.5778L211.278 76.7934L219.108 69.8569L209.185 62.0628C212.387 59.5782 214.884 56.2739 216.687 52.1625ZM206.928 37.8228C206.902 44.0279 205.78 48.7573 203.561 51.9985C201.342 55.2398 198.177 56.8541 194.054 56.8541C189.93 56.8541 186.614 55.1767 184.37 51.8094C182.125 48.442 181.003 43.7126 181.003 37.621V34.7077C181.028 28.5027 182.163 23.7859 184.408 20.5825C186.652 17.3664 189.83 15.7647 193.965 15.7647C198.101 15.7647 201.316 17.3917 203.561 20.6455C205.805 23.8994 206.928 28.654 206.928 34.9221V37.8354V37.8228Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M74.1793 17.3159H80.2442C83.8126 17.3159 86.7505 18.1735 89.058 19.8761L96.573 12.3594C95.8542 11.8424 95.1103 11.3505 94.3285 10.8965C90.1928 8.52544 85.4896 7.35254 80.2442 7.35254H61.8728V22.4615L74.1793 34.7707V17.3285V17.3159Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M94.9086 41.7705C94.5177 46.2729 93.282 49.8547 91.1511 52.478C88.604 55.6183 84.9348 57.1948 80.1181 57.1948H79.4877L74.1793 62.5044L61.8728 50.1952V67.0699H80.3703C85.5905 67.0446 90.281 65.8339 94.4294 63.4629C98.5904 61.0792 101.806 57.7371 104.088 53.4112C106.37 49.0854 107.518 44.1542 107.518 38.605V35.8556C107.518 33.7116 107.341 31.6558 106.988 29.6758L94.9086 41.7579V41.7705Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M94.9844 33.4719C95.0349 34.2286 95.0601 34.9979 95.0601 35.8177V38.9706C95.0601 39.9417 94.997 40.8624 94.9214 41.7578L107.001 29.6757C106.61 27.4434 105.98 25.3246 105.135 23.3193L94.9844 33.4719Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M79.4875 57.1815H74.1791V54.2808L68.5302 48.6307L61.8853 41.9717V50.1946L74.1791 62.4911L79.4875 57.1815Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M79.8283 48.6315L94.9718 33.4846C94.7574 29.8398 94.0261 26.813 92.7778 24.3789L74.1794 42.9814V54.2816L79.8283 48.6315Z"
            fill="#D84B44" />
          <path
            d="M105.122 23.3315L121.98 6.46944L116.331 0.819336L100.847 16.3067C102.045 17.7192 103.104 19.2704 104.025 20.9983C104.428 21.755 104.781 22.5369 105.122 23.3315Z"
            fill="#D84B44" />
          <path
            d="M50.7136 19.498V30.8109L61.8853 41.9723V30.6721L50.7136 19.498Z"
            fill="#D84B44" />
          <path
            d="M61.8853 30.6719V41.9721L68.5302 48.6311L74.1791 54.2812V42.981L61.8853 30.6719Z"
            fill="#D84B44" />
          <path
            d="M105.122 23.3314C104.794 22.5369 104.428 21.755 104.025 20.9982C103.104 19.283 102.045 17.7192 100.847 16.3066L92.7773 24.3782C94.0256 26.8123 94.757 29.8391 94.9713 33.484L105.122 23.3314Z"
            fill="#D84B44" />
          <path
            d="M23.5035 33.9135V16.4965H29.5684C33.1242 16.4965 36.0621 17.3542 38.357 19.0441L45.872 11.5275C45.1532 11.0104 44.4219 10.5185 43.6528 10.0771C39.517 7.7061 34.8138 6.5332 29.5684 6.5332H11.197V21.6674L23.4656 33.9387L23.4909 33.9135H23.5035Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M44.2328 40.9132C43.8419 45.4282 42.6062 49.0226 40.4753 51.6459C37.9282 54.7862 34.259 56.3627 29.4423 56.3627H28.7741L23.4656 61.6723L11.197 49.4009V66.2504H29.6945C34.9147 66.2251 39.6053 65.0144 43.7536 62.6434C47.9146 60.2597 51.1299 56.9176 53.4122 52.5917C55.6944 48.2659 56.8419 43.3347 56.8419 37.7855V35.0361C56.8419 32.8795 56.6653 30.8111 56.3123 28.8311L44.2454 40.9006L44.2328 40.9132Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M44.2957 32.6262C44.3461 33.3956 44.3714 34.1775 44.3714 34.9973V38.1502C44.3714 39.1087 44.3083 40.0168 44.2327 40.8996L56.2995 28.8301C55.9087 26.5978 55.2782 24.479 54.4334 22.4863L44.2957 32.6262Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M28.7867 56.3625H23.5035V53.4365L23.4656 53.4617L17.8168 47.8116L11.197 41.1904V49.4007L23.4656 61.672L28.7867 56.3625Z"
            fill="var(--ddhq-logo-bg)" />
          <path
            d="M44.2955 32.6273C44.0812 28.9951 43.3372 25.9683 42.0889 23.5342L23.5032 42.124V53.4242L29.1268 47.7993L44.3081 32.6147L44.2955 32.6273Z"
            fill="#4575A1" />
          <path
            d="M0 18.6787V29.9915L11.1969 41.1908V29.8906L0 18.6787Z"
            fill="#4575A1" />
          <path
            d="M54.4332 22.4869L71.2663 5.6501L65.6174 0L50.1587 15.4621C51.3692 16.8746 52.4283 18.4385 53.3488 20.1663C53.7523 20.923 54.1053 21.6923 54.4332 22.4869Z"
            fill="#4575A1" />
          <path
            d="M23.4656 42.161L11.197 29.8896V41.1898L17.8168 47.8111L23.4656 53.4612L23.5035 53.4359V42.1231L23.4656 42.161Z"
            fill="#4575A1" />
          <path
            d="M54.4331 22.4867C54.1053 21.7048 53.7523 20.9228 53.3488 20.1661C52.4283 18.4383 51.3565 16.8744 50.1587 15.4619L42.0889 23.5335C43.3372 25.9676 44.0811 28.9944 44.2955 32.6266L54.4331 22.4867Z"
            fill="#4575A1" />
        </g>
        <defs>
          <clipPath id="clip0_1_601">
            <rect
              width="219.385"
              height="78.5591"
              fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </a>
</template>
